import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  getAllSportData,
  addFormData,
  addTransaction,
  getAllPaymentFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import DeleteModel from "../../components/DeleteModel";
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Col, Row, Container } from "react-bootstrap";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import successicon from "../../assests/payments_icon/success.png";
import pendingicon from "../../assests/payments_icon/pending.png";
import canceicon from "../../assests/payments_icon/cancel.png";
import UserDetails from "../User/UserList/UserDetails";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const CoinTransaction = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);

  const userInfo = useSelector((state) => state.auth);
  const [pending, setPending] = useState(true);

  const [viewShow, setViewShow] = useState(false);

  const [rows, setRows] = useState([]);

  const [transData, setTransData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleViewClose = () => setViewShow(false);

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const emptyRows = 0;

  useEffect(() => {
    paymentsData(1, filteredData);
  }, []);

  // withdrawl payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.GET_COIN_TRANSACTION}/${page}/${1000}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          console.log("Coin transaction", response);
          setPending(false);
          // const ITEMS_PER_PAGE = rowsPerPage;
          // setTotalCount(data[0]?.totalcount);
          // const totalCount = data[0]?.totalcount;
          // const totalPagesCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
          // setTotalPages(totalPagesCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const getTransactionDetails = async (custId) => {
    let url = `${endPoints.api.GET_COIN_TRANSAC_Details}/${custId}/1/5`;

    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        console.log("Details", response);
        setIsLoading(false);
        if (response.status === "success") {
          setTransData(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event, newPage) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    paymentsData(page, filteredData);
  }, [rowsPerPage]);

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
  };

  const closeView = () => {
    setViewShow(false);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Coin Transaction
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Paysafe ID </TableCell>
                            <TableCell align="center">Username</TableCell>
                            <TableCell align="center">
                              First & Last Name{" "}
                            </TableCell>

                            <TableCell align="center">Transaction ID</TableCell>
                            <TableCell align="center">
                              Transaction Type
                            </TableCell>
                            <TableCell align="center">Trans Date</TableCell>
                            <TableCell align="center">Amount</TableCell>
                                <TableCell align="center">Settle Amount</TableCell>
                            <TableCell align="center">Status</TableCell>

                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                style={{
                                  backgroundColor:
                                    (!row.payWithBet &&
                                      row.depositSource == "Same") ||
                                    (row.payWithBet &&
                                      row.depositSource == "Different")
                                      ? "yellow"
                                      : !row.payWithBet &&
                                        row.depositSource == "Different"
                                      ? "#f36464"
                                      : null,
                                }}
                              >
                                <TableCell align="center">
                                  {row.id_user}
                                </TableCell>
                                <TableCell align="center">
                                  {row.merchantRefNum}
                                </TableCell>
                                <TableCell align="center">
                                  {row.login}
                                </TableCell>

                                <TableCell align="center">
                                  {row.name} {row.surname}
                                </TableCell>

                                <TableCell align="center">
                                  {row.transaction_id}
                                </TableCell>
                                <TableCell align="center">
                                  {row.rtype == 24
                                    ? "Corepay"
                                    : row.rtype == "2"
                                    ? "Stripe"
                                    : row.rtype == "1"
                                    ? "Skrill"
                                    : row.rtype == "3"
                                    ? "Now Payments"
                                    : ""}
                                </TableCell>
                                <TableCell align="center">
                                  {moment
                                    .utc(row.addeddate)
                                    .format("YYYY-MM-DD")}
                                </TableCell>
                                <TableCell align="center">
                                  {row.amount}
                                </TableCell>
                                  <TableCell align="center">
                                  {row.settleAmount}
                                </TableCell>
                                <TableCell align="center">
                                  {row.status}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <Button
                                    variant="primary"
                                    className="mrglft10"
                                    style={{
                                      background: "#0D3862",
                                      borderRadius: "8px",
                                    }}
                                    onClick={() => {
                                      setViewShow(true);
                                      setCreateData(true);
                                      setEditData(row);
                                      getTransactionDetails(row.id_user);
                                    }}
                                  >
                                    View
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                            {/* <TablePagination
                              className="hide-rows-per-page-options"
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              colSpan={12}
                              count={
                                rowsPerPage === -1 ? rows.length : totalcount
                              }
                              rowsPerPage={rowsPerPage}
                              page={page - 1}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            /> */}
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    {/* ----> */}
                    <Modal
                      show={viewShow}
                      onHide={handleViewClose}
                      // style={{ marginTop: "10%" }}
                      size="xl"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header
                        closeButton
                        style={{ fontSize: "24px", fontWeight: "bold" }}
                      >
                        Transaction Details
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.transaction_id}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.amount}</td>
                                  </tr>

                                  <tr>
                                    <th>Transaction type:</th>
                                    <td>
                                      {editData.type == 24
                                        ? "Corepay"
                                        : "Skrill"}
                                    </td>
                                    <th>Status</th>
                                    <td>{editData.status}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>

                          <div className="col-md-12">
                            <TableContainer component={Paper}>
                              <Table
                                className="c_table"
                                size="small"
                                aria-label="a dense table"
                                stickyHeader
                                sx={{ minWidth: 500 }}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="center">
                                      Transaction Date
                                    </TableCell>
                                    <TableCell align="center">Amount</TableCell>
                                    <TableCell align="center">
                                      Transaction Type{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {transData.map((row) => (
                                    <TableRow
                                      key={row.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell align="center">
                                        {moment
                                          .utc(row.insertion_time)
                                          .format("YYYY-MM-DD")}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.amount}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.txtype}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>

                          <Row>
                            <Col xs={12} className="text-center">
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{ width: "30%", marginTop: "20px" }}
                                onClick={closeView}
                              >
                                Close
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoinTransaction;
